import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const JamaicaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15200'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15200)'>
				<rect
					width='20'
					height='14'
					fill='#1DBE4F'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 0L8.57143 7L0 14V0Z'
					fill='#262626'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M20 0L11.4286 7L20 14V0Z'
					fill='#262626'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.0007 5.87416L-0.915339 -1.34155L-1.98047 0.205984L8.29757 6.99996L-1.98047 13.7939L-0.915339 15.3415L10.0007 8.12576L20.9168 15.3415L21.9819 13.7939L11.7038 6.99996L21.9819 0.205985L20.9168 -1.34155L10.0007 5.87416Z'
					fill='#FFD646'
				/>
			</g>
		</svg>
	);
};

export default JamaicaFlagIcon;
